import { useTranslations } from 'next-intl';
import React, { type ReactNode } from 'react';
import { Confetti } from '@mentimeter/confetti';
import { designSystemConfig } from '@mentimeter/ragnar-dsc';
import { WorkspaceRoleEnum } from '@mentimeter/http-clients';
import { type GetInvitesResponse } from '@core-api/workspace-members/workspace-members/invites/{token}';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Button } from '@mentimeter/ragnar-ui/button';
import { Heading, P, Strong } from '@mentimeter/ragnar-ui/typography';
import { ModalContainer } from './ModalContainer';
import hands1 from './images/hands-2.svg';

const StrongText = (children: ReactNode) => Strong({ children });

export const JoinTeamSuccessModalContent = ({
  teamName,
  onActionClick,
  actionText,
  role,
}: {
  teamName: string;
  onActionClick: () => void;
  actionText: string;
  role: GetInvitesResponse['invitedRole'];
}) => {
  const t = useTranslations('onboarding.join_workspace');

  return (
    <>
      <Confetti
        colors={[...designSystemConfig.visualizationColors.fillColors]}
      />
      <ModalContainer dissmissable={false} image={hands1.src}>
        <Box
          flexDirection="column"
          justifyContent="space-between"
          overflow="auto"
          flex="1 1 auto"
          width="100%"
        >
          <Box width="100%">
            <Heading mb={2}>{t('welcome_message', { teamName })}</Heading>
            {role === WorkspaceRoleEnum.MEMBER_LITE ? (
              <P mt={3} mb={2}>
                {t.rich('member_lite_congratulations_message', {
                  Strong: StrongText,
                  teamName,
                })}
              </P>
            ) : (
              <P mt={3} mb={2}>
                {t.rich('member_congratulations_message', {
                  Strong: StrongText,
                  teamName,
                })}
              </P>
            )}
          </Box>
        </Box>
        <Box flexDirection="row" width="100%" justifyContent="flex-end">
          <Button variant="primary" onClick={onActionClick}>
            {actionText}
          </Button>
        </Box>
      </ModalContainer>
    </>
  );
};
